import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { withRouter } from 'react-router'
import { EngineInformation, TechnicalRecords, EngineCondition, EngineStand, PowerPlant, FleetComposition, TechnicalSummary, PhysicalReview, MliTab, ExportDialog } from '../components';
import { ExportManu, PageLoader } from '../../../shared_elements';
import { FormSkeletonLoader, FormWrapper } from '../../Elements';
import { checkApiStatus, downloadFileType, getLocalStorageInfo } from '../../../utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
import moment from 'moment';
import { regexConstants } from '../../../constants/regEx';
import { globalGetService, globalPostService } from '../../../utils_v2/globalApiServices';
import { globalExportService } from '../../../utils_v2/globalApiServices';
import { assetTypeId } from '../../../constants';
import Skeleton from '@material-ui/lab/Skeleton';
import useWindowHeight from '../../../shared_elements/hooks/useWindowHeight';
import { Tabs, Tab, Paper } from '@material-ui/core';

const LeaseInsecpectionReport = ({ params }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const windowHeight = useWindowHeight();
    const [skeltonLoader, setSkeltonLoader] = useState(true);
    const [currentFormDetail, setCurrentFormDetail] = useState(null);
    const [data, setData] = useState(null)
    const [errors, setErrors] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [basicDropdown, setBasicDropdown] = useState({})
    const [usersList, setUsersList] = useState([]);
    const [initialValue, setInitialValue] = useState('');
    const [tabValue, setTabValue] = useState('mli')
    const [formSave, setFormSave] = useState({ open: false, type: '',isdisabled:false })
    const [exportModal,setExportModal]=useState({modal:false,data:null})
    const onTab = (event, neValue) => {
        setTabValue(neValue)
    }
    const exportReports = [
        { title: 'MLI', extension: 'pdf', key: 'mli', value: 1 },
        { title: 'Physical Review', extension: 'pdf', key: 'review', value: 2 },
        { title: 'MLI & Physical Review', extension: 'pdf', key: 'both', value: 3 },
        { title: 'Mini MLI', extension: 'pdf', key: 'mini_report', value: 4 },
        { title: 'Mini MLI & Physical Review', extension: 'pdf', key: 'mini_mli_physical', value: 5 },
    ]


    const onFieldChange = (e, key, value, extraParam, index, date, nestedParam, nestedIndex) => {
        setData(prev => {
            if (extraParam === 'key_attendees' || nestedParam === 'tech_open_action' || nestedParam === 'powerplant_management' || nestedParam === 'powerplant_maintenance' || nestedParam === 'power_fleet_composition' || nestedParam === 'next_sv_date') {
                if (nestedParam === 'tech_open_action' || nestedParam === 'powerplant_maintenance' || nestedParam === 'powerplant_management' || nestedParam === 'power_fleet_composition' || nestedParam === 'next_sv_date') {
                    if (nestedParam === 'powerplant_maintenance') {
                        if (key === 'description') {
                            const updatedArray = prev[extraParam] ? [...prev[extraParam][nestedParam]] : [];
                            updatedArray[index] = { ...(updatedArray[index] || {}), [key]: value };
                            return { ...prev, [extraParam]: { ...prev[extraParam], [nestedParam]: updatedArray } };
                        } else {
                            const updatedModules = prev[extraParam][nestedParam].map((module, moduleIndex) => {
                                if (moduleIndex === nestedIndex) {
                                    const updatedKeyValues = module.key_values.map((kv, kvIndex) => {
                                        if (kvIndex === index) {
                                            return { ...kv, [key]: value };
                                        }
                                        return kv;
                                    });
                                    return { ...module, key_values: updatedKeyValues };
                                }
                                return module;
                            });
                            return { ...prev, [extraParam]: { ...prev[extraParam], [nestedParam]: updatedModules } };
                        }
                    } else {
                        const updatedArray = prev[extraParam] ? [...prev[extraParam][nestedParam]] : [];
                        updatedArray[index] = { ...(updatedArray[index] || {}), [key]: value };
                        return { ...prev, [extraParam]: { ...prev[extraParam], [nestedParam]: updatedArray } }
                    }
                } else {
                    const updatedArray = prev.key_attendees ? [...prev.key_attendees] : [];
                    updatedArray[index] = { ...(updatedArray[index] || {}), [key]: value };
                    return { ...prev, key_attendees: updatedArray };
                }
            } else {
                if (extraParam) {
                    if (nestedParam) {
                        if (nestedParam === "tech_record_management_para" && (value === 'viewed' || !value)) {
                            return {
                                ...prev,
                                [extraParam]: { ...prev[extraParam], [nestedParam]: { ...prev[extraParam]?.[nestedParam] || {}, ['is_facility']: value, ['is_room']: null, ['manage']: null } }
                            };
                        } else {
                            return {
                                ...prev,
                                [extraParam]: { ...prev[extraParam], [nestedParam]: { ...prev[extraParam]?.[nestedParam] || {}, [key]: value } }
                            };
                        }

                    }
                    return { ...prev, [extraParam]: { ...prev[extraParam], [key]: value }, };
                }
                return { ...prev, [key]: value };
            }
        });
    };

    useEffect(() => {
        getCurrentFormDetail('skeltonLoader');
        getDropdown()
        getEngineFormsdata('skeltonLoader')
        getUsersListFn()
        trackActivity('Project Management', {
            event_type: 'Page Visited',
            page_title: 'T015 Form'
        });
    }, []);

    const getUsersListFn = () => {
        globalGetService('camo/camo_user_list/?application=19&form=true')
            .then(response => {
                if (checkApiStatus(response)) {
                    setUsersList(response.data.data)
                }
            })
    }

    const getDropdown = () => {
        globalGetService(`/technical/t015/basic_dropdown/`)
            .then(response => {
                if (response?.status == 200) {
                    setBasicDropdown(response?.data)
                }
            })
    }

    const callthisapi = (itemData, neValue) => {
        setLoading(true)
        let validationInputs = {}
        if (data?.key_attendees) {
            data.key_attendees.forEach((attendee, index) => {
                const emailData = attendee?.email?.trim() || ''
                if (!regexConstants.email.test(emailData)) {
                    validationInputs[index] = {
                        ...validationInputs[index],
                        email: attendee?.email === '' || attendee?.email === null ? '' : 'Please enter a valid Email Address',
                    };
                }
            });
        }
        let payload = Object.assign({}, itemData ? itemData : data)
        delete payload?.lessor_id
        delete payload?.work_order
        delete payload?.engine_condition_stands?.fh_fc_ratio
        delete payload?.engine_condition_stands?.expected_fh_interval?.achieve_fhs
        delete payload?.engine_condition_stands?.expected_fh_interval?.interval_fhs
        payload = {
            ...payload,
            serial_number: currentFormDetail?.asset?.asset_type === 1 ? currentFormDetail?.asset?.msn : currentFormDetail?.asset?.esn,
            model_id: currentFormDetail?.asset?.asset_type === 1 ? currentFormDetail?.asset?.aircraft_type : currentFormDetail?.asset?.engine_type,
            technical_records: {
                ...payload?.technical_records,
                tsn: payload?.technical_records?.tsn ? parseFloat(payload?.technical_records?.tsn) : null,
                csn: payload?.technical_records?.csn ? parseInt(payload?.technical_records?.csn) : null,
            },
            engine_condition_stands: {
                ...payload?.engine_condition_stands,
                stand_color: payload?.engine_condition_stands?.stand_color || null,
                avg_fh: payload?.engine_condition_stands?.avg_fh ? parseFloat(payload?.engine_condition_stands?.avg_fh) : null,
                avg_fc: payload?.engine_condition_stands?.avg_fc ? parseFloat(payload?.engine_condition_stands?.avg_fc) : null,
                csl_hsv: payload?.engine_condition_stands?.csl_hsv ? parseInt(payload?.engine_condition_stands?.csl_hsv) : null,
                avg_derate_percentage: payload?.engine_condition_stands?.avg_derate_percentage ? parseFloat(payload?.engine_condition_stands?.avg_derate_percentage) : null,
                tsl_hsv: payload?.engine_condition_stands?.tsl_hsv ? parseFloat(payload?.engine_condition_stands?.tsl_hsv) : null,
                expected_fh_interval: {
                    ...payload?.engine_condition_stands?.expected_fh_interval,
                    thrust_is: payload?.engine_condition_stands?.expected_fh_interval?.thrust_is ? parseInt(payload?.engine_condition_stands?.expected_fh_interval?.thrust_is) : null,
                    trending_at: payload?.engine_condition_stands?.expected_fh_interval?.trending_at >= 0 || '0' ? parseFloat(payload?.engine_condition_stands?.expected_fh_interval?.trending_at) : null,
                    average_of: payload?.engine_condition_stands?.expected_fh_interval?.average_of >= 0 || '0' ? parseFloat(payload?.engine_condition_stands?.expected_fh_interval?.average_of) : null,
                },
                expected_fc_interval: {
                    ...payload?.engine_condition_stands?.expected_fc_interval,
                    remaining_at: parseInt(payload?.current_tr) || null,
                    engine_fcs: payload?.engine_condition_stands?.expected_fc_interval?.engine_fcs ? parseFloat(payload?.engine_condition_stands?.expected_fc_interval?.engine_fcs) : null,
                    fcs_remaining: payload?.engine_condition_stands?.expected_fc_interval?.fcs_remaining ? parseFloat(payload?.engine_condition_stands?.expected_fc_interval?.fcs_remaining) : null,
                    removal_fcs: payload?.engine_condition_stands?.expected_fc_interval?.removal_fcs ? parseFloat(payload?.engine_condition_stands?.expected_fc_interval?.removal_fcs) : null,
                }
            },
        }
        const shouldCallAPI = Object.values(validationInputs).every(
            (errorObj) => !errorObj?.email
        );
        if (shouldCallAPI) {
            globalPostService(`/technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/review/${assetTypeId[params?.type]}/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        getEngineFormsdata()
                        setLoading(false)
                        getCurrentFormDetail();
                        setFormSave({ open: false, type: '' });
                        setErrors({})
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    } else {
                        setLoading(false)
                        setErrors({})
                        setFormSave({ open: false, type: '' });
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });

                    }
                });
        } else {
            setErrors(validationInputs)
            setFormSave({ open: false, type: 'engine_inspection' });
            setLoading(false)
        }
    }
    const exportFn = (file) => {
        if ([2, 3, 5].includes(file?.value)) {
            setExportModal({ modal: true, data: file })
        } else {
             exportFormReport(file)
        }
    }

    const exportFormReport = (file, selectedValue) => {
        setLoading(true)
        globalExportService(file?.key === 'review' ? `/technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/physical-review/export/${assetTypeId[params?.type]}/` :
            `/technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/export/${assetTypeId[params?.type]}/`,
            file?.key === 'both' ? { download: file?.extension, both: 'yes', include_engines: selectedValue } : file?.key === 'mini_report' ? { download: file?.extension, mini_report: 'yes' } : file?.key === 'mini_mli_physical' ? { download: file?.extension, mini_mli_physical: 'yes', include_engines: selectedValue } : { download: file?.extension, include_engines: selectedValue },true)
            .then(response => {
                  if (response?.statusCode >= 400 || response?.isJson) {
                      setLoading(false)
                      enqueueSnackbar(response?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                      trackActivity('Project Management', {
                          event_type: 'File Exported Failed',
                          page_title: 'T015 Form',
                          workOrderSlug: params?.workOrderSlug ? params.workOrderSlug : '',
                          file_name: `T015_${getLocalStorageInfo().defaultLessor?.name}_${moment().format('YYYY-MM-DD')}`,
                          file_extension: file?.extension,
                          error_msg: response?.message
                      })
                  } else {
                    enqueueSnackbar('T015 Report Downloading ...', { variant: 'info', anchorOrigin: { horizontal: 'right', vertical: 'bottom' } })
                    setLoading(false)
                    downloadFileType(response?.blob, (file?.key === 'review' ?
                        `T015_PhysicalReview_${getLocalStorageInfo().defaultLessor?.name}_${moment().format('YYYY-MM-DD')}.` :
                        file?.key === 'both' ? `T015_MLI_PhysicalReview_${getLocalStorageInfo().defaultLessor?.name}_${moment().format('YYYY-MM-DD')}.`
                            : file?.key === 'mini_report' ?
                                `T015_Mini_MLI_${getLocalStorageInfo().defaultLessor?.name}_${moment().format('YYYY-MM-DD')}.` :
                                file?.key === 'mini_mli_physical' ? `T015_Mini_MLI_PhysicalReview${getLocalStorageInfo().defaultLessor?.name}_${moment().format('YYYY-MM-DD')}.` :
                                    `T015_MLI_${getLocalStorageInfo().defaultLessor?.name}_${moment().format('YYYY-MM-DD')}.`
                    ), file?.extension);
                    closeSnackbar();
                    setExportModal({ modal: false, data: null })
                    trackActivity('Project Management', {
                        event_type: 'File Exported',
                        page_title: 'T015 Form',
                        workOrderSlug: params?.workOrderSlug ? params.workOrderSlug : '',
                        file_name: `T015_${getLocalStorageInfo().defaultLessor?.name}_${moment().format('YYYY-MM-DD')}`,
                        file_extension: file?.extension,
                        success_msg: 'T015 Report Downloaded'
                    })
                 }

            });
    }

    const getEngineFormsdata = (loaderType) => {
        if (loaderType) { setSkeltonLoader(true) }
        globalGetService(`/technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/review/${assetTypeId[params?.type]}/`)
            .then(response => {
                if (loaderType) { setSkeltonLoader(false) }
                if (checkApiStatus(response)) {
                    setData(response.data.data || {});
                } else {
                    setData({});
                }
            })
            .catch(() => {
                setData({});
                if (loaderType) { setSkeltonLoader(false) }
            });
    }

    const getCurrentFormDetail = (loaderType) => {
        if (loaderType) { setSkeltonLoader(true) }
        globalGetService(`technical/${params.type === 'engine' ? 'engine-workorder' : 'workorder'}/${params?.workOrderSlug}/forms/?asset_type=${params?.type}`, { form: params.formSlug, fields: 'id,name,project_number,start_date,expected_end_date,slug' })
            .then(response => {
                if (loaderType) { setSkeltonLoader(false) }
                if (checkApiStatus(response)) {
                    setCurrentFormDetail(response?.data?.data)
                }
            })
    }
    const onChangeFormStatus = (data) => {
        setLoading(true)
        globalPostService(`technical/workorder/${params?.workOrderSlug}/form/${params?.formSlug}/status-update/?asset_type=${params?.type}`, data)
            .then(response => {
                setLoading(false)
                if (checkApiStatus(response)) {
                    getCurrentFormDetail('formLoader');
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Project Management', {
                        event_type: 'Form Status Updated',
                        page_title: 'T015 Form',
                        form_slug: params?.formSlug || '',
                        workOrder_slug: params?.workOrderSlug || '',
                        status: data?.status ? data?.status : '',
                        request_body: data || '',
                        success_msg: response?.data?.message
                    });
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Project Management', {
                        event_type: 'Form Status Update Failed',
                        page_title: 'T014 Form',
                        form_slug: params?.formSlug || '',
                        workOrder_slug: params?.workOrderSlug || '',
                        status: data?.status || '',
                        request_body: data || '',
                        error_source: 'Backend',
                        error_msg: response?.data?.message
                    });
                }
            });
    }

    const digitalSigntureUpload = (item, fieldType) => {
        setLoading(true)
        let formData = new FormData();
        if (item?.length) {
            item.map(items => {
                formData.append('files', items)
            })
        }
        globalPostService(
            `technical/t015/basic-inspection/${params?.workOrderSlug}/forms/${params?.formSlug}/tct015basicinpection/${data?.id}/attachment/${assetTypeId[params?.type]}/?field=${fieldType}`, formData)
            .then(response => {
                setLoading(false)
                if (checkApiStatus(response)) {
                    getEngineFormsdata()
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Project Management', {
                        event_type: 'Digital Signature Upload Success',
                        page_title: 'T015 Form MLI',
                        form_slug: params?.formSlug || '',
                        workOrder_slug: params?.workOrderSlug || '',
                        field_key: fieldType === '1' ? "Inspector Digital Signature" : "Reviewer Digital Signature",
                        success_msg: response?.data?.message
                    });
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Project Management', {
                        event_type: 'Digital Signature Upload Failed',
                        page_title: 'T015 Form MLI',
                        form_slug: params?.formSlug || '',
                        workOrder_slug: params?.workOrderSlug || '',
                        field_key: fieldType === '1' ? "Inspector Digital Signature" : "Reviewer Digital Signature",
                        error_msg: response?.data?.message
                    });
                }
            });
    }

    let formViewPermission = currentFormDetail?.list?.length && currentFormDetail?.list?.find(form => form.slug == currentFormDetail?.current_form?.slug)
    let formType = window.location?.pathname?.toUpperCase()?.includes(currentFormDetail?.current_form?.name)

    return (
        <section className='project-forms-section form-t015'>
            {currentFormDetail && Object.keys(currentFormDetail).length && formViewPermission && formType ?
                <FormWrapper
                    hideAction={currentFormDetail?.current_form.progress === 0 ? true : false}
                    formInfo={currentFormDetail}
                    exportReportBtn={<ExportManu disabled={currentFormDetail?.current_form.progress === 0 ? true : false} exportReportFn={(file) => exportFn(file)} title="Export Report" files={exportReports} />}
                    updateFormStatusFn={(data) => onChangeFormStatus(data)}

                /> : skeltonLoader ? <FormSkeletonLoader /> : null
            }
            {skeltonLoader ?
                <Paper square className='mli-tab' elevation={2}>
                    <Tabs indicatorColor='primary' value={false}>
                        <Tab label={<Skeleton variant="rect" animation='wave' width={50} height={20} />} />
                        <Tab label={<Skeleton variant="rect" animation='wave' width={150} height={20} />} />
                    </Tabs>
                </Paper> :
                <MliTab
                    tabValue={tabValue}
                    onChangeTab={onTab}
                />
            }
            {skeltonLoader ?
                <Skeleton variant="rect" animation='wave' width={'100%'} height={windowHeight * 0.8} /> :
            tabValue === 'mli' ?
                data ? (<>
                    <EngineInformation
                        data={data}
                        setData={setData}
                        setInitialValue={setInitialValue}
                        usersList={usersList}
                        basicDropdown={basicDropdown}
                        onFieldChange={onFieldChange}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        getResponseBack={() => getEngineFormsdata()}
                        currentFormDetail={currentFormDetail}
                        setLoading={setLoading}
                        isLoading={isLoading}
                        setFormSave={setFormSave}
                        formSave={formSave}
                        errors={errors}
                        setErrors={setErrors}
                    />
                    <TechnicalRecords
                        data={data}
                        setData={setData}
                        onFieldChange={onFieldChange}
                        setInitialValue={setInitialValue}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        getResponseBack={() => getEngineFormsdata()}
                        currentFormDetail={currentFormDetail}
                        isLoading={isLoading}
                        setFormSave={setFormSave}
                        formSave={formSave}
                    />
                    <EngineCondition
                        data={data}
                        setData={setData}
                        onFieldChange={onFieldChange}
                        setInitialValue={setInitialValue}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        getResponseBack={() => getEngineFormsdata()}
                        currentFormDetail={currentFormDetail}
                        setLoading={setLoading}
                        isLoading={isLoading}
                        setFormSave={setFormSave}
                        formSave={formSave}
                    />
                    <EngineStand
                        data={data}
                        setData={setData}
                        onFieldChange={onFieldChange}
                        setInitialValue={setInitialValue}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        getResponseBack={() => getEngineFormsdata()}
                        currentFormDetail={currentFormDetail}
                        setLoading={setLoading}
                        isLoading={isLoading}
                        setFormSave={setFormSave}
                        formSave={formSave}
                    />
                    <PowerPlant
                        data={data}
                        setData={setData}
                        onFieldChange={onFieldChange}
                        setInitialValue={setInitialValue}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        getResponseBack={() => getEngineFormsdata()}
                        currentFormDetail={currentFormDetail}
                        setLoading={setLoading}
                        isLoading={isLoading}
                        setFormSave={setFormSave}
                        formSave={formSave}
                    />
                    <FleetComposition
                        data={data}
                        setData={setData}
                        onFieldChange={onFieldChange}
                        setInitialValue={setInitialValue}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        getResponseBack={() => getEngineFormsdata()}
                        currentFormDetail={currentFormDetail}
                        setLoading={setLoading}
                        isLoading={isLoading}
                        setFormSave={setFormSave}
                        formSave={formSave}
                    />
                    <TechnicalSummary
                        data={data}
                        setData={setData}
                        onFieldChange={onFieldChange}
                        setInitialValue={setInitialValue}
                        callthisapi={(item, neValue) => callthisapi(item, neValue)}
                        getResponseBack={() => getEngineFormsdata()}
                        currentFormDetail={currentFormDetail}
                        setLoading={setLoading}
                        isLoading={isLoading}
                        setFormSave={setFormSave}
                        formSave={formSave}
                        digitalSigntureUpload={digitalSigntureUpload}
                    />
                </>) : null
                : tabValue === 'review' ?
                    <PhysicalReview
                        getResponseBackForm={() => getCurrentFormDetail()}
                        currentFormDetail={currentFormDetail}
                    /> : null
            }
            {
                exportModal?.modal ?
                    <ExportDialog
                        exportModal={exportModal?.data}
                        toggleModalFn={() => setExportModal({ modal: false, data: null })}
                        exportFormReport={exportFormReport}
                    /> : null
            }
            {isLoading ? <PageLoader /> : null}

        </section>
    )
}

export default withRouter(LeaseInsecpectionReport)